<script setup lang="ts">
import useWorkspace from '@/composition/useWorkspace';
import {legacyModeKey, useDialogs, useLocalization} from '@hantera/portal-app';
import {ToggleSwitch} from '@hantera/design-system';
import LegacyQuickSearch from '@/components/LegacyQuickSearch';
import QuickSearch from '@/components/QuickSearch';
import {inject, ref, watch} from 'vue';
import useBackend from '@/composition/useBackend';

const workspace = useWorkspace();
const t = useLocalization();
const { graph, queries } = useBackend();
const dialogs = useDialogs();
//const quickSearch = useTemplateRef('quickSearch');
const legacyMode = inject(legacyModeKey, false);

const useNewQuickSearch = ref(!legacyMode || (workspace.state.useNewQuickSearch ?? true));
watch(useNewQuickSearch, async (val) => {
  workspace.state.useNewQuickSearch = val;
});

</script>

<template>
  <div class="new-viewer">

    <div class="search__container">
      <label class="mode-toggle" v-if="legacyMode">
        <ToggleSwitch v-model="useNewQuickSearch" />
        Use new search (beta)
      </label>
      
      <LegacyQuickSearch
        v-if="!useNewQuickSearch"
      />
      <QuickSearch v-else />
    </div>

  </div>
</template>

<style scoped>

.search__container {
  margin-top: 10vh;
  max-width: 400px;
  width: 100%;
  padding: 0 20px;
}

.new-viewer {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.mode-toggle {
  text-align: center;
  margin-bottom: 50px;
}

</style>

